const rankingItems = [
  { rank: 1, title: '暗夜追踪', type: '动作悬疑', hot: '9.8', trend: 'up', desc: '年度黑马悬疑大片，反转不断全程高能' },
  { rank: 2, title: '春风十里不如你', type: '都市爱情', hot: '9.6', trend: 'up', desc: '高甜都市恋爱剧，全网播放量破50亿' },
  { rank: 3, title: '极限挑战第10季', type: '户外综艺', hot: '9.5', trend: 'stable', desc: '王牌综艺回归，笑点密集全程无尿点' },
  { rank: 4, title: '深海密码', type: '科幻冒险', hot: '9.3', trend: 'up', desc: '国产科幻新标杆，视觉震撼口碑爆棚' },
  { rank: 5, title: '长安十二时辰', type: '古装权谋', hot: '9.2', trend: 'down', desc: '经典古装悬疑剧，细节拉满百看不厌' },
  { rank: 6, title: '奔跑吧第8季', type: '竞技综艺', hot: '9.0', trend: 'stable', desc: '国民综艺持续火爆，每周必看欢乐不断' },
];

function TrendIcon({ trend }: { trend: string }) {
  if (trend === 'up') return <i className="ri-arrow-up-line text-primary-500 text-xs"></i>;
  if (trend === 'down') return <i className="ri-arrow-down-line text-foreground-400 text-xs"></i>;
  return <i className="ri-subtract-line text-secondary-500 text-xs"></i>;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            热播排行榜
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto leading-relaxed">
            根据播放量、搜索热度与用户评分综合排序
          </p>
        </div>
        <div className="max-w-4xl mx-auto bg-background-50 rounded-2xl overflow-hidden">
          {rankingItems.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer hover:bg-background-100 transition-colors ${
                i < rankingItems.length - 1 ? 'border-b border-background-200' : ''
              }`}
            >
              <span
                className={`flex-shrink-0 w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center text-sm font-bold ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 bg-background-200 text-foreground-600 text-xs rounded-md whitespace-nowrap">
                    {item.type}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
                  {item.desc}
                </p>
              </div>
              <div className="flex items-center gap-1.5 flex-shrink-0">
                <TrendIcon trend={item.trend} />
                <span className="text-sm font-bold text-accent-500 whitespace-nowrap">{item.hot}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}